import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/logo-icon.png'


const _hoisted_1 = { class: "row align-items-center header-inner-area" }
const _hoisted_2 = { class: "col-6 col-lg-5" }
const _hoisted_3 = { class: "left-header-content" }
const _hoisted_4 = { class: "d-flex align-items-center ps-0 mb-0 list-unstyled justify-content-start" }
const _hoisted_5 = { class: "logo" }
const _hoisted_6 = { class: "burger-menu d-none d-lg-block" }
const _hoisted_7 = { class: "col-6 col-lg-7" }
const _hoisted_8 = { class: "right-header-content mt-2 mt-sm-0" }
const _hoisted_9 = { class: "d-flex align-items-center justify-content-end ps-0 mb-0 list-unstyled" }
const _hoisted_10 = { class: "header-right-item" }
const _hoisted_11 = { class: "header-right-item" }
const _hoisted_12 = { class: "header-right-item mobile-burger-menu burger-menu d-lg-none" }

import { ref, onMounted } from "vue";
import stateStore from "@/utils/store";

import SearchFrom from "./SearchFrom.vue";
import WebApps from "./WebApps.vue";
import DarkSwtichBtn from "./DarkSwtichBtn.vue";
import LanguageMenu from "./LanguageMenu.vue";
import ToggleFullscreenBtn from "./ToggleFullscreenBtn.vue";
import NotificationsLists from "./NotificationsLists.vue";
import AdminProfile from "./AdminProfile.vue";
import AuthButtons from "./AuthButtons.vue"; // New import
import SettingsBtn from "./SettingsBtn.vue";
import Navbar from "./Navbar.vue";

import { authStore } from '@/stores/auth'; // New import


export default /*@__PURE__*/_defineComponent({
  __name: 'TopHeader',
  setup(__props) {

const stateStoreInstance = stateStore;
const isSticky = ref(false);

onMounted(() => {
  window.addEventListener("scroll", () => {
    let scrollPos = window.scrollY;
    isSticky.value = scrollPos >= 100;
  });
});

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("header", {
    class: _normalizeClass([
      'header-area bg-white mb-4 rounded-bottom-15',
      { sticky: isSticky.value },
    ])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("ul", _hoisted_4, [
            _createElementVNode("li", _hoisted_5, [
              _createVNode(_component_RouterLink, {
                to: "/dashboard",
                class: "d-block d-md-none text-decoration-none"
              }, {
                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                  _createElementVNode("img", {
                    class: "logo-black",
                    src: _imports_0,
                    alt: "logo-icon",
                    style: {"max-width":"25px"}
                  }, null, -1),
                  _createElementVNode("img", {
                    class: "logo-white",
                    src: _imports_0,
                    alt: "logo-icon",
                    style: {"max-width":"25px"}
                  }, null, -1)
                ]))]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_6, [
              _createElementVNode("button", {
                class: _normalizeClass(["header-burger-menu bg-transparent p-0 border-0", [
                  'header-burger-menu bg-transparent p-0 border-0',
                  { active: _unref(stateStoreInstance).open },
                ]]),
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(stateStoreInstance).onChange && _unref(stateStoreInstance).onChange(...args)))
              }, [...(_cache[3] || (_cache[3] = [
                _createElementVNode("span", { class: "material-symbols-outlined" }, "menu", -1)
              ]))], 2)
            ]),
            _cache[4] || (_cache[4] = _createElementVNode("li", null, null, -1))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("ul", _hoisted_9, [
            _createElementVNode("li", _hoisted_10, [
              _createVNode(DarkSwtichBtn)
            ]),
            _createElementVNode("li", _hoisted_11, [
              (_unref(authStore).isLoggedIn.value)
                ? (_openBlock(), _createBlock(AdminProfile, { key: 0 }))
                : (_openBlock(), _createBlock(AuthButtons, { key: 1 }))
            ]),
            _createElementVNode("li", _hoisted_12, [
              _createElementVNode("button", {
                class: _normalizeClass(["header-burger-menu bg-transparent p-0 border-0", [
                  'header-burger-menu bg-transparent p-0 border-0',
                  { active: _unref(stateStoreInstance).open },
                ]]),
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(stateStoreInstance).onChange && _unref(stateStoreInstance).onChange(...args)))
              }, [...(_cache[5] || (_cache[5] = [
                _createElementVNode("span", { class: "material-symbols-outlined" }, "menu", -1)
              ]))], 2)
            ])
          ])
        ])
      ])
    ]),
    _createVNode(Navbar)
  ], 2))
}
}

})